const article = {
  slug: 'move-in',
  title: 'Move-in (new tenant)',
  section: 'Daily tasks',
  body: `
# Move in a new tenant

There are three ways a tenant starts, and they converge on the same
lifecycle: **Account -> Sign lease -> Pay -> Gate code -> Active.**

## 1. Website move-in (self-serve)

Tenants use your public rent page, pick a unit, sign the lease
electronically, and pay online. Everything below happens automatically:
welcome email, signing link, payment, gate-code email, invoices.

## 2. Operator move-in (at the counter)

1. **Customers -> Add Customer** (or find the existing record).
2. **Rentals -> New Rental** - pick customer + available unit. The unit
   flips to Occupied.
3. Send the lease for signature (rental row -> lease actions). The tenant
   signs by typed name from the emailed link.
4. Take the first payment (**Payments -> Take payment** or the card icon
   on the customer row).
5. The gate-code email fires **after payment succeeds** - not after
   signing.

## 3. Add existing tenant (migration / already renting)

Use **Customers -> Add Existing Tenant** for someone who already rents
from you but isn't in the system (e.g. brought over from a previous
PMS). It creates the customer + unit + active rental marked
**paid-current** - no back-invoices, no signing link, first invoice on
the next sweep.

> A stalled move-in is never chased by email. The abandoned draft is
> cleaned up automatically (the unit frees up), and the person surfaces
> in **Leads and Reservations -> Leads** so your team can follow up
> deliberately.
`,
};

export default article;
